module.exports = __webpack_public_path__ + "media/images/no_declarations-51dc65f586173058247ef9e09a4e2388.svg";